export const parseValidationErrors = (errors, defaultError) => {
    if (errors === undefined)
        return defaultError;
    if (typeof errors === 'string')
        return errors;
    const validationErrors = Object.values(errors);
    return validationErrors?.length ? validationErrors.join(' ') : defaultError;
};
